import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const relationTypes = {
    cabinBaggagePerTraveller: "BY_TRAVELLER",
    flexibleTicket: "BY_TRAVELLER",
    seatingBesides: "BY_FLIGHT_PRODUCT",
    travelInsurance: "BY_TRAVELLER",
    checkedInBaggage: "BY_TRAVELLER",
    mealPreference: "BY_TRAVELLER",
    seatingPreference: "BY_TRAVELLER",
    specialBags: "BY_TRAVELLER",
    cancelForAnyReason: "BY_ORDER",
    seatMapSelection: "BY_FLIGHT_SEGMENT_AND_LEG"
};
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                extraProducts: {},
                fetchStatus: "loading",
                error: undefined
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                extraProducts: action.payload.extraProducts,
                fetchStatus: "success",
                error: undefined
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload.error,
                extraProducts: undefined
            };
        case ActionTypes.addProduct: {
            const { product, productType } = action.payload;
            const productRelation = relationTypes[productType];
            let currentSelection = state.selected[productType] || [];
            switch (productRelation) {
                case "BY_TRAVELLER":
                    if (currentSelection && "travellerReference" in product && product.travellerReference) {
                        currentSelection = currentSelection.filter((item) => {
                            return item.travellerReference !== product.travellerReference;
                        });
                    }
                    return {
                        ...state,
                        selected: {
                            ...state.selected,
                            [productType]: [...currentSelection, action.payload.product]
                        }
                    };
                case "BY_FLIGHT_SEGMENT_AND_LEG":
                    if (currentSelection && product?.travellerReference) {
                        switch (productType) {
                            case "seatMapSelection":
                                const { travellerReference, segmentIndex, legIndex } = product;
                                currentSelection = currentSelection.filter((item) => {
                                    return !(item.travellerReference === travellerReference &&
                                        item.segmentIndex === segmentIndex &&
                                        item.legIndex === legIndex);
                                });
                        }
                    }
                    return {
                        ...state,
                        selected: {
                            ...state.selected,
                            [productType]: [...currentSelection, action.payload.product]
                        }
                    };
                case "BY_ORDER":
                    return {
                        ...state,
                        selected: {
                            ...state.selected,
                            [productType]: [action.payload.product]
                        }
                    };
                default:
                    return {
                        ...state,
                        selected: {
                            ...state.selected,
                            [productType]: [action.payload.product]
                        }
                    };
            }
        }
        case ActionTypes.setProducts: {
            const { products, productType } = action.payload;
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [productType]: products
                }
            };
        }
        case ActionTypes.syncProductsFromExternalStore: {
            const { products } = action.payload;
            return {
                ...state,
                selected: products
            };
        }
        case ActionTypes.removeProduct: {
            const { travellerReference = "", airProductReference, productType, segmentIndex, legIndex } = action.payload;
            const currentSelection = state.selected[productType] || [];
            let selection = undefined;
            if (travellerReference && segmentIndex !== undefined && legIndex !== undefined) {
                selection = currentSelection.filter((product) => {
                    return !(product.travellerReference === travellerReference &&
                        product.segmentIndex === segmentIndex &&
                        product.legIndex === legIndex);
                });
            }
            else if (travellerReference) {
                selection = currentSelection.filter((product) => {
                    return !("travellerReference" in product && product.travellerReference === travellerReference);
                });
            }
            else if (airProductReference) {
                selection = currentSelection.filter((product) => {
                    return !("airProductReference" in product && product.airProductReference === airProductReference);
                });
            }
            else {
                const selected = { ...state.selected };
                delete selected[productType];
                return { ...state, selected };
            }
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [productType]: selection
                }
            };
        }
        case ActionTypes.removeAllProducts: {
            const selected = { ...state.selected };
            delete selected[action.payload.productType];
            return { ...state, selected };
        }
        case ActionTypes.addPreOptInProduct: {
            const { productType, product } = action.payload;
            return {
                ...state,
                preOptedAncillaries: { ...state.preOptedAncillaries, [productType]: product }
            };
        }
        case ActionTypes.removePreOptInProduct: {
            const { productType } = action.payload;
            const preOptedAncillaries = { ...state.preOptedAncillaries };
            delete preOptedAncillaries[productType];
            return {
                ...state,
                preOptedAncillaries
            };
        }
        case ActionTypes.resetPreOptIn: {
            return {
                ...state,
                preOptedAncillaries: {}
            };
        }
        case ActionTypes.reset: {
            return {
                ...getInitialState(),
                preOptedAncillaries: state.preOptedAncillaries
            };
        }
        case ActionTypes.resetSelectedExtraProducts: {
            return {
                ...state,
                selected: {}
            };
        }
        case ActionTypes.setPageLoadTime: {
            return {
                ...state,
                pageLoadTime: { ...state.pageLoadTime, ...action.payload }
            };
        }
        default:
            return state;
    }
};
export { reducer, getInitialState };
